"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.getCountryCode = void 0;

var O = __importStar(require("fp-ts/lib/Option"));

var pipeable_1 = require("fp-ts/lib/pipeable");

var countries_json_1 = __importDefault(require("./countries.json"));
/**
 * Sanitize a country name
 *
 * @ignore
 */


function sanitize(input) {
  return input // Lowercase
  .toLowerCase() // Remove all spaces
  .replace(/ /g, '') // Remove all "-"
  .replace(/-/g, '');
}
/**
 * Given a country name, gets the ISO 3166-1 Alpha-2 code of the country
 *
 * @param input - The country name, can contain multiple spaces, dashes...
 * @example
 * ```typescript
 * getCountryCode('united   States'); // 'US'
 * ```
 */


function getCountryCode(input) {
  return pipeable_1.pipe(O.fromNullable(countries_json_1["default"].find(function (_a) {
    var code = _a.code,
        name = _a.name,
        others = _a.others;
    var sName = sanitize(name);
    var sInput = sanitize(input);
    return sName === sInput || code === sInput || sName.includes(sInput) || sInput.includes(sName) || others.includes(sInput);
  })), O.map(function (_a) {
    var code = _a.code;
    return code;
  }));
}

exports.getCountryCode = getCountryCode;